import React, { useEffect } from "react";

import MallLoginComponent from "../common/MallLoginComponent";

const SignInLoginComponent = () => {
	useEffect(() => {
		const timer = setTimeout(() => {
			window.scrollTo({
				top: 0,
				behavior: "smooth",
			});
			return () => clearTimeout(timer);
		}, 100);
	}, []);

	return (
		<div className="noselect landing-home landing-new-home">
			<div className={`together-landing-banner-wrap sign-in-login-banner-wrap`}>
				<img
					src={`/assets/images/landing/landing-bg-2.png`}
					alt={`당영 투게더 1`}
				/>
				<div className={`together-landing-banner-title-wrap`}>
					<h1>로그인</h1>
					<p>당영투게더에 오신 것을 환영합니다.</p>
				</div>
			</div>
			<div className={`together-landing-banner-img-div`}>
				<div style={{ display: "flex", justifyContent: "center" }}>
					<MallLoginComponent />
				</div>
			</div>
		</div>
	);
};
export default SignInLoginComponent;
